// src/utils/submit.ts
import axios from 'axios';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var {value} = info;
    }
    catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    }
    else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function () {
        const self = this; const args = arguments;
        return new Promise((resolve, reject) => {
            const gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'next', value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    }
    else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for (let i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        let ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(sym => Object.getOwnPropertyDescriptor(source, sym).enumerable));
        }
        ownKeys.forEach(key => {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    let f; let y; let t; let g; let _ = {
        label: 0,
        sent() {
            if (t[0] & 1) {
                throw t[1];
            }
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        throw: verb(1),
        return: verb(2)
    }, typeof Symbol === 'function' && (g[Symbol.iterator] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) {
            throw new TypeError('Generator is already executing.');
        }
        while (_) {
            try {
                if (f = 1, y && (t = op[0] & 2 ? y.return : op[0] ? y.throw || ((t = y.return) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) {
                    return t;
                }
                if (y = 0, t) {
                    op = [
                        op[0] & 2,
                        t.value
                    ];
                }
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) {
                            _.ops.pop();
                        }
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        }
        if (op[0] & 5) {
            throw op[1];
        }
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
// src/config/config.ts
const CONFIG_DATA = {
    version: '1.0.2',
    successSoundUrl: 'https://interactive-cdn.gaotu100.com/cw-lab/audio/right.mp3',
    api: {
        coursewareQuestions: 'interactive_courseware/courseware_questions',
        answerQuestion: 'coursewareCommon/answerQuestion',
        answerSubmitClazzGroupQuestion: 'coursewareCommon/answerSubmitClazzGroupQuestion',
        submitQuestion: 'coursewareCommon/submitQuestionV2',
        coursewareDetail: 'interactive_courseware/courseware_detail',
        statisticStudent: 'interactive_courseware/statistic_student',
        answerAndSubmitQuestion: 'coursewareCommon/answerAndSubmit'
    },
    env: {
        test: {
            jiaoyanBackendBaseUrl: 'https://test-interactive.gaotu100.com/'
        },
        development: {
            jiaoyanBackendBaseUrl: 'https://test-interactive.gaotu100.com/'
        },
        beta: {
            jiaoyanBackendBaseUrl: 'https://beta-interactive.gaotu100.com/'
        },
        production: {
            jiaoyanBackendBaseUrl: 'https://interactive.gaotu100.com/'
        }
    }
};
const config_default = CONFIG_DATA;
// src/utils/utils.ts
function getLocationHref() {
    return window.location.href || window.location.search;
}
let allUrlQuery;
function getUrlQuery() {
    let name = '';
    let value = '';
    let strTmp = getLocationHref();
    const query = {};
    if (strTmp) {
        let num = strTmp.lastIndexOf('?');
        strTmp = strTmp.substr(num + 1);
        const arrTmp = strTmp.split('&');
        for (let i = 0; i < arrTmp.length; i++) {
            num = arrTmp[i].indexOf('=');
            if (num > 0) {
                name = arrTmp[i].substring(0, num);
                value = arrTmp[i].substr(num + 1);
                query[name] = i === arrTmp.length - 1 && /#\/$/.test(value) ? value.slice(0, -2) : value;
            }
        }
    }
    return query;
}
function getQuery(name) {
    if (!allUrlQuery) {
        allUrlQuery = getUrlQuery();
    }
    return allUrlQuery[name];
}
function getAllQuery() {
    if (!allUrlQuery) {
        allUrlQuery = getUrlQuery();
    }
    return allUrlQuery;
}
function getJiaoyanBackendUrl() {
    return '/';
}
function isBigClassSmallGroup() {
    return getQuery('roomType') === '1';
}
function getBizTypeByEntryType(entryType) {
    const entryTypeBizProjectMap = {
        previewHomeworkClazzQuiz: 2,
        homeworkClazzQuiz: 3,
        errorBookQuiz: 4
    };
    const bizType = entryTypeBizProjectMap[entryType] || 1;
    return bizType;
}
const startTime = /* @__PURE__ */ new Date().getTime();
function isPreview() {
    const {userNumber} = getAllQuery();
    return !userNumber;
}
function isAssistant() {
    return getQuery('role') === 'assistant';
}
// src/utils/hybrid.ts
function getParamsString(params) {
    if (typeof params !== 'object') {
        return params;
    }
    let attr = '';
    for (attr in params) {
        if (typeof params[attr] === 'number' || typeof params[attr] === 'boolean') {
            params[attr] = ''.concat(params[attr]);
        }
        else if (!params[attr]) {
            params[attr] = '';
        }
    }
    return params;
}
function hybridDataReport(postData) {
    const bridgeName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'send';
    const client = getQuery('client');
    getParamsString(postData);
    getParamsString(postData && postData.params);
    if (client === 'android' || client === 'harmony') {
        try {
            window.bridge[bridgeName](JSON.stringify(postData));
        }
        catch (error) {}
    }
    else if (client === 'ios') {
        if (window.webkit && window.webkit.messageHandlers[bridgeName]) {
            window.webkit.messageHandlers[bridgeName].postMessage(postData);
        }
    }
}
function heartbeatInPC() {
    if (window.parent === window) {
        return;
    }
    const origin = '*';
    window.parent.postMessage({
        type: 'interactiveQuiz',
        cmd: 0,
        data: {},
        from: 'gaotu',
        request: []
    }, origin);
}
function startHeartbeat() {
    const interval = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 2e3;
    heartbeatInPC();
    window.setInterval(() => heartbeatInPC(), interval);
}
// src/utils/submit.ts
function getStudentCoursewareQuestionsInfo() {
    const {cocosId} = getAllQuery();
    const answerDuration = /* @__PURE__ */ new Date().getTime() - startTime;
    const info = {
        // 互动题id
        questionId: cocosId,
        // 固定是1
        questionVersion: 1,
        // 答题花费时间
        spendTime: answerDuration,
        // 0：错，1:对，2：半对
        status: 1,
        itemBaseList: [
            {
                // 固定值
                resourceType: 11,
                resource: [
                    {
                        idx: 1,
                        info: 'A',
                        isCorrect: true
                    }
                ],
                extendResource: {
                    rightNumber: 1,
                    wrongNumber: 0
                }
            }
        ]
    };
    return [info];
}
function getAnswerAndSubmitQuestionParams() {
    const _getAllQuery = getAllQuery(); const _getAllQuery_role = _getAllQuery.role; const role = _getAllQuery_role === void 0 ? '' : _getAllQuery_role; const _getAllQuery_subRoomNumber = _getAllQuery// cocosId = '',
        .subRoomNumber; const subRoomNumber = _getAllQuery_subRoomNumber === void 0 ? '' : _getAllQuery_subRoomNumber; const _getAllQuery_entryType = _getAllQuery.entryType; const entryType = _getAllQuery_entryType === void 0 ? '' : _getAllQuery_entryType; const _getAllQuery_coursewareOpenRecordNumber = _getAllQuery.coursewareOpenRecordNumber; const coursewareOpenRecordNumber = _getAllQuery_coursewareOpenRecordNumber === void 0 ? '' : _getAllQuery_coursewareOpenRecordNumber; const _getAllQuery_userNumber = _getAllQuery.userNumber; const userNumber = _getAllQuery_userNumber === void 0 ? '' : _getAllQuery_userNumber; const _getAllQuery_type = _getAllQuery.type; const type = _getAllQuery_type === void 0 ? '' : _getAllQuery_type; const _getAllQuery_bizNumber = _getAllQuery.bizNumber; const bizNumber = _getAllQuery_bizNumber === void 0 ? '' : _getAllQuery_bizNumber; const _getAllQuery_clazzLessonNumber = _getAllQuery.clazzLessonNumber; let clazzLessonNumber = _getAllQuery_clazzLessonNumber === void 0 ? '' : _getAllQuery_clazzLessonNumber; const _getAllQuery_curClassType = _getAllQuery.curClassType; const curClassType = _getAllQuery_curClassType === void 0 ? '' : _getAllQuery_curClassType; const _getAllQuery_processV = _getAllQuery.processV; const processV = _getAllQuery_processV === void 0 ? '' : _getAllQuery_processV; const _getAllQuery_avatarTeamNumber = _getAllQuery.avatarTeamNumber; let avatarTeamNumber = _getAllQuery_avatarTeamNumber === void 0 ? '' : _getAllQuery_avatarTeamNumber; const _getAllQuery_avatarLegionNumber = _getAllQuery.avatarLegionNumber; let avatarLegionNumber = _getAllQuery_avatarLegionNumber === void 0 ? '' : _getAllQuery_avatarLegionNumber; const _getAllQuery_sessionId = _getAllQuery// roomType = '',
        .sessionId; const sessionId = _getAllQuery_sessionId === void 0 ? '' : _getAllQuery_sessionId; const _getAllQuery_roomNumber = _getAllQuery.roomNumber; const roomNumber = _getAllQuery_roomNumber === void 0 ? '' : _getAllQuery_roomNumber;
    const submitItems = getStudentCoursewareQuestionsInfo();
    if (clazzLessonNumber === 'undefined' || clazzLessonNumber === 'null') {
        clazzLessonNumber = '';
    }
    let bizType = getBizTypeByEntryType(entryType);
    const isBigClass = isBigClassSmallGroup();
    if (isBigClass) {
        bizType = 5;
    }
    const isPlayBack = type === 'playback' || entryType === 'homeworkClazzQuiz';
    const answerDuration = /* @__PURE__ */ new Date().getTime() - startTime;
    const params = {
        bizNumber: coursewareOpenRecordNumber || bizNumber,
        submitItems,
        userId: userNumber,
        bizType,
        bizStructure: {
            userRole: role,
            subRoomNumber,
            questionCount: 1,
            clazzLessonNumber,
            isPlayBack,
            classType: curClassType,
            sessionId,
            roomNumber
        },
        questionType: 0
    };
    if (isBigClass) {
        if (avatarTeamNumber === 'undefined' || avatarTeamNumber === 'null') {
            avatarTeamNumber = '';
        }
        if (avatarLegionNumber === 'undefined' || avatarLegionNumber === 'null') {
            avatarLegionNumber = '';
        }
        params.answerDuration = answerDuration;
        params.bizStructure.processV = processV;
        params.bizStructure.avatarTeamNumber = avatarTeamNumber;
        params.bizStructure.avatarLegionNumber = avatarLegionNumber;
    }
    return params;
}
function rpcAnswerAndSubmitQuestion() {
    return _rpcAnswerAndSubmitQuestion.apply(this, arguments);
}
function _rpcAnswerAndSubmitQuestion() {
    _rpcAnswerAndSubmitQuestion = _async_to_generator(function () {
        let url; let params; let answerQuestionData; let _answerQuestionData_data_data; let _answerQuestionData_data; let _answerQuestionData_data_data1; let _answerQuestionData_data1; let _answerQuestionData_data_data2; let _answerQuestionData_data2;
        return _ts_generator(this, _state => {
            switch (_state.label) {
                case 0:
                    url = getJiaoyanBackendUrl() + config_default.api.answerAndSubmitQuestion;
                    params = getAnswerAndSubmitQuestionParams();
                    return [
                        4,
                        axios.post(url, params)
                    ];
                case 1:
                    answerQuestionData = _state.sent();
                    if (isBigClassSmallGroup()) {

                        if (answerQuestionData === null || answerQuestionData === void 0 ? void 0 : (_answerQuestionData_data = answerQuestionData.data) === null || _answerQuestionData_data === void 0 ? void 0 : (_answerQuestionData_data_data = _answerQuestionData_data.data) === null || _answerQuestionData_data_data === void 0 ? void 0 : _answerQuestionData_data_data.answerResult) {
                            answerQuestionData.data.data = _object_spread({}, answerQuestionData.data.data.answerResult);
                        }
                    }
                    else if ((answerQuestionData === null || answerQuestionData === void 0 ? void 0 : (_answerQuestionData_data1 = answerQuestionData.data) === null || _answerQuestionData_data1 === void 0 ? void 0 : (_answerQuestionData_data_data1 = _answerQuestionData_data1.data) === null || _answerQuestionData_data_data1 === void 0 ? void 0 : _answerQuestionData_data_data1.answerResult) && (answerQuestionData === null || answerQuestionData === void 0 ? void 0 : (_answerQuestionData_data2 = answerQuestionData.data) === null || _answerQuestionData_data2 === void 0 ? void 0 : (_answerQuestionData_data_data2 = _answerQuestionData_data2.data) === null || _answerQuestionData_data_data2 === void 0 ? void 0 : _answerQuestionData_data_data2.submitResult)) {
                        answerQuestionData.data.data = _object_spread({}, answerQuestionData.data.data.answerResult, answerQuestionData.data.data.submitResult);
                    }
                    return [
                        2,
                        answerQuestionData === null || answerQuestionData === void 0 ? void 0 : answerQuestionData.data
                    ];
            }
        });
    });
    return _rpcAnswerAndSubmitQuestion.apply(this, arguments);
}
function formatTitleData(data) {
    if (data) {
        if (data.continuous_correct_times) {
            data.continuousCorrectTimes = data.continuous_correct_times;
        }
        if (data.praise_message) {
            data.praiseMessage = data.praise_message;
        }
        if (data.status_msgs) {
            data.statusMsgs = data.status_msgs;
        }
        if (data.user_show_info) {
            data.userShowInfo = data.user_show_info;
            if (data.userShowInfo.title_url) {
                data.userShowInfo.titleUrl = data.userShowInfo.title_url;
            }
        }
    }
    return data;
}
function sendMessage(sendData) {
    const client = getQuery('client');
    if (client === 'android' || client === 'harmony') {
        try {
            let _myWindow_bridge;
            const myWindow = window;
            myWindow === null || myWindow === void 0 ? void 0 : (_myWindow_bridge = myWindow.bridge) === null || _myWindow_bridge === void 0 ? void 0 : _myWindow_bridge.send(JSON.stringify(sendData));
        }
        catch (error) {}
    }
    else if (client === 'ios') {
        let _myWindow_webkit_messageHandlers; let _myWindow_webkit;
        const myWindow1 = window;
        if (myWindow1 === null || myWindow1 === void 0 ? void 0 : (_myWindow_webkit = myWindow1.webkit) === null || _myWindow_webkit === void 0 ? void 0 : (_myWindow_webkit_messageHandlers = _myWindow_webkit.messageHandlers) === null || _myWindow_webkit_messageHandlers === void 0 ? void 0 : _myWindow_webkit_messageHandlers.send) {
            myWindow1.webkit.messageHandlers.send.postMessage(sendData);
        }
    }
    else {
        window.parent.postMessage(sendData, '*');
    }
}
function sendCoursewareReadyOrSubmit() {
    const params = arguments.length > 0 && arguments[0] !== void 0
        ? arguments[0]
        : {
            key: 'iframeShow',
            data: {}
        };
    const _params_key = params.key; const key = _params_key === void 0 ? 'iframeShow' : _params_key; const _params_data = params.data; const data = _params_data === void 0 ? {} : _params_data;
    const sendData = {
        from: 'gaotu',
        type: 'interactiveQuiz',
        // 向直播页面发送消息
        cmd: 128,
        data: {
            key,
            data,
            submitTime: +new Date()
        }
    };
    sendMessage(sendData);
}
function sendChangeTitleMessage2Client(responseData) {
    const changeTitleData = responseData.data;
    formatTitleData(changeTitleData);
    const doubleHitData = {
        from: 'gaotu',
        type: 'interactiveQuiz',
        // 向直播页面发送消息
        cmd: 128,
        data: {
            // 用户头衔改变
            key: 'user_title_change',
            value: {
                title: changeTitleData.userShowInfo && changeTitleData.userShowInfo.title,
                successiveHitTimes: changeTitleData.continuousCorrectTimes,
                statusMsgs: changeTitleData.statusMsgs,
                praiseMessage: changeTitleData.praiseMessage,
                titleUrl: changeTitleData.userShowInfo && changeTitleData.userShowInfo.titleUrl,
                response: changeTitleData
            }
        }
    };
    const client = getQuery('client');
    if (client === 'android' || client === 'harmony') {
        try {
            let _myWindow_bridge;
            const myWindow = window;
            myWindow === null || myWindow === void 0 ? void 0 : (_myWindow_bridge = myWindow.bridge) === null || _myWindow_bridge === void 0 ? void 0 : _myWindow_bridge.send(JSON.stringify(doubleHitData));
        }
        catch (error) {}
    }
    else if (client === 'ios') {
        let _myWindow_webkit_messageHandlers; let _myWindow_webkit;
        const myWindow1 = window;
        if (myWindow1 === null || myWindow1 === void 0 ? void 0 : (_myWindow_webkit = myWindow1.webkit) === null || _myWindow_webkit === void 0 ? void 0 : (_myWindow_webkit_messageHandlers = _myWindow_webkit.messageHandlers) === null || _myWindow_webkit_messageHandlers === void 0 ? void 0 : _myWindow_webkit_messageHandlers.operationNotice) {
            myWindow1.webkit.messageHandlers.operationNotice.postMessage(doubleHitData);
        }
    }
    else {
        window.parent.postMessage(doubleHitData, '*');
    }
}
function sendAddCoinMessage2Client() {
    const client = getQuery('client');
    if (client === 'android' || client === 'harmony') {
        const addCoinsData = {
            type: 'addCoins'
        };
        try {
            let _myWindow_bridge;
            const myWindow = window;
            myWindow === null || myWindow === void 0 ? void 0 : (_myWindow_bridge = myWindow.bridge) === null || _myWindow_bridge === void 0 ? void 0 : _myWindow_bridge.send(JSON.stringify(addCoinsData));
        }
        catch (error) {}
    }
    else if (client === 'ios') {
        let _myWindow_webkit_messageHandlers; let _myWindow_webkit;
        const myWindow1 = window;
        if (myWindow1 === null || myWindow1 === void 0 ? void 0 : (_myWindow_webkit = myWindow1.webkit) === null || _myWindow_webkit === void 0 ? void 0 : (_myWindow_webkit_messageHandlers = _myWindow_webkit.messageHandlers) === null || _myWindow_webkit_messageHandlers === void 0 ? void 0 : _myWindow_webkit_messageHandlers.addCoins) {
            myWindow1.webkit.messageHandlers.addCoins.postMessage({});
        }
    }
    else {
        window.parent.postMessage({
            data: {},
            from: 'gaotu',
            request: [],
            cmd: 1,
            type: 'interactiveQuiz',
            target: 'progressBar'
        }, '*');
    }
}
function sendSubmitMessage2Client() {
    const client = getQuery('client');
    if (client === 'android' || client === 'ios' || client === 'harmony') {
        hybridDataReport({
            type: 'closeLessonAffirm'
        });
    }
    else {
        window.parent.postMessage({
            cmd: 128,
            from: 'gaotu',
            type: 'interactiveQuiz',
            data: {
                isSubmit: true
            }
        }, '*');
    }
}
function sendCloseAssMessage2Client() {
    let _window_parent; let _window;
    (_window = window) === null || _window === void 0
        ? void 0
        : (_window_parent = _window.parent) === null || _window_parent === void 0
            ? void 0
            : _window_parent.postMessage({
                type: 'assFinishAnswer'
            }, '*');
}
function sendCloseMessage2Client() {
    const client = getQuery('client');
    if (client === 'android' || client === 'harmony') {
        const data = {
            type: 'closeWin'
        };
        try {
            const myWindow = window;
            myWindow.bridge.send(JSON.stringify(data));
        }
        catch (error) {}
    }
    else if (client === 'ios') {
        let _myWindow_webkit_messageHandlers; let _myWindow_webkit;
        const myWindow1 = window;
        if (myWindow1 === null || myWindow1 === void 0 ? void 0 : (_myWindow_webkit = myWindow1.webkit) === null || _myWindow_webkit === void 0 ? void 0 : (_myWindow_webkit_messageHandlers = _myWindow_webkit.messageHandlers) === null || _myWindow_webkit_messageHandlers === void 0 ? void 0 : _myWindow_webkit_messageHandlers.closeWin) {
            myWindow1.webkit.messageHandlers.closeWin.postMessage({});
        }
    }
    else {
        let _window_parent; let _window;
        (_window = window) === null || _window === void 0
            ? void 0
            : (_window_parent = _window.parent) === null || _window_parent === void 0
                ? void 0
                : _window_parent.postMessage({
                    cmd: 2,
                    from: 'gaotu',
                    type: 'interactiveQuiz',
                    data: {},
                    request: []
                }, '*');
    }
}
function sendMessage2Client(postData) {
    const type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'send';
    const descStr = JSON.stringify(postData);
    const client = getQuery('client');
    const myWindow = window;
    if (myWindow) {
        switch (client) {
            case 'android':
            case 'harmony':
                var _myWindow_bridge_type; var _myWindow_bridge;
                (_myWindow_bridge = myWindow.bridge) === null || _myWindow_bridge === void 0 ? void 0 : (_myWindow_bridge_type = _myWindow_bridge[type]) === null || _myWindow_bridge_type === void 0 ? void 0 : _myWindow_bridge_type.call(_myWindow_bridge, descStr);
                break;
            case 'ios':
                var _myWindow_webkit;
                if ((_myWindow_webkit = myWindow.webkit) === null || _myWindow_webkit === void 0 ? void 0 : _myWindow_webkit.messageHandlers[type]) {
                    myWindow.webkit.messageHandlers[type].postMessage(postData);
                }
                break;
            default:
                var _postData_data; var _postData_data1; var _myWindow_habo;
                if (postData === null || postData === void 0 ? void 0 : (_postData_data = postData.data) === null || _postData_data === void 0 ? void 0 : _postData_data.params) {
                    myWindow === null || myWindow === void 0 ? void 0 : (_myWindow_habo = myWindow.habo) === null || _myWindow_habo === void 0 ? void 0 : _myWindow_habo.click(postData === null || postData === void 0 ? void 0 : (_postData_data1 = postData.data) === null || _postData_data1 === void 0 ? void 0 : _postData_data1.params);
                }
                break;
        }
    }
}
function sendAnswerFinishMessage2Client() {
    const entryType = getQuery('entryType');
    switch (entryType) {
        case 'previewHomeworkClazzQuiz':
            sendMessage2Client({
                type: 'previewHomeworkFinish'
            });
            break;
        case 'homeworkClazzQuiz':
            sendMessage2Client({}, 'loadNextQuestion');
            break;
        default:
            sendCloseMessage2Client();
            break;
    }
}
function submitNormalClass() {
    return _submitNormalClass.apply(this, arguments);
}
function _submitNormalClass() {
    _submitNormalClass = _async_to_generator(function () {
        let _answerRes_data_submitResult; let _answerRes_data; let _answerRes_data1; let _answerRes_data_submitResult1; let _answerRes_data2; let _answerRes_data3; let answerRes; let coin; let extraCoin; let err;
        return _ts_generator(this, _state => {
            switch (_state.label) {
                case 0:
                    _state.trys.push([
                        0,
                        2,,
                        3
                    ]);
                    return [
                        4,
                        rpcAnswerAndSubmitQuestion()
                    ];
                case 1:
                    answerRes = _state.sent();
                    sendChangeTitleMessage2Client(answerRes);
                    sendAddCoinMessage2Client();
                    sendSubmitMessage2Client();
                    coin = (answerRes === null || answerRes === void 0 ? void 0 : (_answerRes_data = answerRes.data) === null || _answerRes_data === void 0 ? void 0 : (_answerRes_data_submitResult = _answerRes_data.submitResult) === null || _answerRes_data_submitResult === void 0 ? void 0 : _answerRes_data_submitResult.coinCount) || (answerRes === null || answerRes === void 0 ? void 0 : (_answerRes_data1 = answerRes.data) === null || _answerRes_data1 === void 0 ? void 0 : _answerRes_data1.coinCount) || 0;
                    extraCoin = (answerRes === null || answerRes === void 0 ? void 0 : (_answerRes_data2 = answerRes.data) === null || _answerRes_data2 === void 0 ? void 0 : (_answerRes_data_submitResult1 = _answerRes_data2.submitResult) === null || _answerRes_data_submitResult1 === void 0 ? void 0 : _answerRes_data_submitResult1.extraCoin) || (answerRes === null || answerRes === void 0 ? void 0 : (_answerRes_data3 = answerRes.data) === null || _answerRes_data3 === void 0 ? void 0 : _answerRes_data3.extraCoin) || 0;
                    return [
                        2,
                        coin + extraCoin
                    ];
                case 2:
                    err = _state.sent();
                    return [
                        2,
                        0
                    ];
                case 3:
                    return [2];
            }
        });
    });
    return _submitNormalClass.apply(this, arguments);
}
function submitBigClassSmallGroup() {
    return _submitBigClassSmallGroup.apply(this, arguments);
}
function _submitBigClassSmallGroup() {
    _submitBigClassSmallGroup = _async_to_generator(function () {
        let _answerRes_data_submitResult; let _answerRes_data; let _answerRes_data1; let _answerRes_data_submitResult1; let _answerRes_data2; let _answerRes_data3; let answerRes; let key; let coin; let extraCoin;
        return _ts_generator(this, _state => {
            switch (_state.label) {
                case 0:
                    return [
                        4,
                        rpcAnswerAndSubmitQuestion()
                    ];
                case 1:
                    answerRes = _state.sent();
                    key = 'submitClose';
                    sendCoursewareReadyOrSubmit({
                        key,
                        data: answerRes
                    });
                    coin = (answerRes === null || answerRes === void 0 ? void 0 : (_answerRes_data = answerRes.data) === null || _answerRes_data === void 0 ? void 0 : (_answerRes_data_submitResult = _answerRes_data.submitResult) === null || _answerRes_data_submitResult === void 0 ? void 0 : _answerRes_data_submitResult.coinCount) || (answerRes === null || answerRes === void 0 ? void 0 : (_answerRes_data1 = answerRes.data) === null || _answerRes_data1 === void 0 ? void 0 : _answerRes_data1.coinCount) || 0;
                    extraCoin = (answerRes === null || answerRes === void 0 ? void 0 : (_answerRes_data2 = answerRes.data) === null || _answerRes_data2 === void 0 ? void 0 : (_answerRes_data_submitResult1 = _answerRes_data2.submitResult) === null || _answerRes_data_submitResult1 === void 0 ? void 0 : _answerRes_data_submitResult1.extraCoin) || (answerRes === null || answerRes === void 0 ? void 0 : (_answerRes_data3 = answerRes.data) === null || _answerRes_data3 === void 0 ? void 0 : _answerRes_data3.extraCoin) || 0;
                    return [
                        2,
                        coin + extraCoin
                    ];
            }
        });
    });
    return _submitBigClassSmallGroup.apply(this, arguments);
}
function submitAnswer() {
    return _submitAnswer.apply(this, arguments);
}
function _submitAnswer() {
    _submitAnswer = _async_to_generator(function () {
        let coin; let err;
        return _ts_generator(this, _state => {
            switch (_state.label) {
                case 0:
                    coin = 0;
                    if (isPreview()) {
                        return [
                            2,
                            0
                        ];
                    }
                    if (!isBigClassSmallGroup()) {
                        return [
                            3,
                            6
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        submitBigClassSmallGroup()
                    ];
                case 2:
                    coin = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    err = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    sendCloseMessage2Client();
                    return [7];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    return [
                        4,
                        submitNormalClass()
                    ];
                case 7:
                    coin = _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        2,
                        coin
                    ];
            }
        });
    });
    return _submitAnswer.apply(this, arguments);
}
function closeWindow() {
    const closeAssWaitTime = 1500;
    const closeWaitTime = 5e3;
    if (isAssistant()) {
        setTimeout(() => {
            sendCloseAssMessage2Client();
        }, closeAssWaitTime);
    }
    setTimeout(() => {
        sendAnswerFinishMessage2Client();
    }, closeWaitTime);
}
function rpcStatisticStudent(_) {
    return _rpcStatisticStudent.apply(this, arguments);
}
function _rpcStatisticStudent() {
    _rpcStatisticStudent = _async_to_generator(function (param) {
        let _param_status; let status; let url; let _getAllQuery; let role; let client; let type; let _getAllQuery_version; let version; let _getAllQuery_roomNumber; let roomNumber; let _getAllQuery_subRoomNumber; let subRoomNumber; let userNumber; let _getAllQuery_coursewareOpenRecordNumber; let coursewareOpenRecordNumber; let lessonId; let _getAllQuery_preLoad; // 是否预加载 1
        let preLoad; let _getAllQuery_preload; let preload; let curClassType; let deviceTypeList; let params; let formData; let key; let questionList;
        return _ts_generator(this, _state => {
            switch (_state.label) {
                case 0:
                    _param_status = param.status, status = _param_status === void 0 ? 1 : _param_status;
                    url = getJiaoyanBackendUrl() + config_default.api.statisticStudent;
                    _getAllQuery = getAllQuery(), role = _getAllQuery.role, client = _getAllQuery.client, type = _getAllQuery.type, _getAllQuery_version = _getAllQuery.version, version = _getAllQuery_version === void 0 ? '' : _getAllQuery_version, _getAllQuery_roomNumber = _getAllQuery.roomNumber, roomNumber = _getAllQuery_roomNumber === void 0 ? '' : _getAllQuery_roomNumber, _getAllQuery_subRoomNumber = _getAllQuery.subRoomNumber, subRoomNumber = _getAllQuery_subRoomNumber === void 0 ? '' : _getAllQuery_subRoomNumber, userNumber = _getAllQuery.userNumber, _getAllQuery_coursewareOpenRecordNumber = _getAllQuery.coursewareOpenRecordNumber, coursewareOpenRecordNumber = _getAllQuery_coursewareOpenRecordNumber === void 0 ? '' : _getAllQuery_coursewareOpenRecordNumber, lessonId = _getAllQuery.lessonId, _getAllQuery_preLoad = _getAllQuery.preLoad, preLoad = _getAllQuery_preLoad === void 0 ? '' : _getAllQuery_preLoad, _getAllQuery_preload = _getAllQuery.preload, preload = _getAllQuery_preload === void 0 ? '' : _getAllQuery_preload, curClassType = _getAllQuery.curClassType;
                    if (role !== 'student') {
                        return [
                            2,
                            Promise.resolve({})
                        ];
                    }
                    deviceTypeList = {
                        pc: 0,
                        android: 1,
                        ios: 2
                    };
                    params = {
                        status,
                        app_version: version,
                        preload: preLoad || preload,
                        room_number: roomNumber || '1',
                        subclazz_room_number: subRoomNumber || '1',
                        lesson_id: lessonId || '1',
                        cur_class_type: curClassType || '1',
                        record_number: coursewareOpenRecordNumber || '1',
                        user_id: userNumber || '1',
                        userRole: role || '1',
                        client: deviceTypeList[client] || 0,
                        deviceType: deviceTypeList[client] || 0,
                        isPlayBack: type === 'live' ? 0 : 1,
                        type: type || '1'
                    };
                    formData = new FormData();
                    for (const key in params) {
                        if (key) {
                            formData.append(key, params[key]);
                        }
                    }
                    return [
                        4,
                        axios.post(url, formData)
                    ];
                case 1:
                    questionList = _state.sent();
                    return [
                        2,
                        questionList === null || questionList === void 0 ? void 0 : questionList.data
                    ];
            }
        });
    });
    return _rpcStatisticStudent.apply(this, arguments);
}
export {closeWindow, rpcStatisticStudent, startHeartbeat, submitAnswer};
